/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsmBuildingDto
 */
export interface OsmBuildingDto {
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    geometryType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    coordinates?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    building?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    image?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    mapillary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    refBag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    source?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OsmBuildingDto
     */
    sourceDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    wikidata?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OsmBuildingDto
     */
    wikipedia?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsmBuildingDto
     */
    isHighlighted?: boolean;
}

/**
 * Check if a given object implements the OsmBuildingDto interface.
 */
export function instanceOfOsmBuildingDto(value: object): value is OsmBuildingDto {
    return true;
}

export function OsmBuildingDtoFromJSON(json: any): OsmBuildingDto {
    return OsmBuildingDtoFromJSONTyped(json, false);
}

export function OsmBuildingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsmBuildingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'geometryType': json['geometryType'] == null ? undefined : json['geometryType'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
        'building': json['building'] == null ? undefined : json['building'],
        'image': json['image'] == null ? undefined : json['image'],
        'mapillary': json['mapillary'] == null ? undefined : json['mapillary'],
        'refBag': json['refBag'] == null ? undefined : json['refBag'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceDate': json['sourceDate'] == null ? undefined : (new Date(json['sourceDate'])),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'wikidata': json['wikidata'] == null ? undefined : json['wikidata'],
        'wikipedia': json['wikipedia'] == null ? undefined : json['wikipedia'],
        'isHighlighted': json['isHighlighted'] == null ? undefined : json['isHighlighted'],
    };
}

export function OsmBuildingDtoToJSON(json: any): OsmBuildingDto {
    return OsmBuildingDtoToJSONTyped(json, false);
}

export function OsmBuildingDtoToJSONTyped(value?: OsmBuildingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'geometryType': value['geometryType'],
        'coordinates': value['coordinates'],
        'building': value['building'],
        'image': value['image'],
        'mapillary': value['mapillary'],
        'refBag': value['refBag'],
        'source': value['source'],
        'sourceDate': value['sourceDate'] == null ? value['sourceDate'] : value['sourceDate'].toISOString(),
        'startDate': value['startDate'],
        'wikidata': value['wikidata'],
        'wikipedia': value['wikipedia'],
        'isHighlighted': value['isHighlighted'],
    };
}

